import { render, staticRenderFns } from "./live.vue?vue&type=template&id=4ea1680a&scoped=true"
import script from "./live.vue?vue&type=script&lang=ts"
export * from "./live.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea1680a",
  null
  
)

export default component.exports